import { Circle } from '@react-pdf/renderer'
import React from 'react'

const CheckCircle = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <Circle cx="12" cy="12" r="12" fill="#e6f5ef" />
        <path
          d="M10.575 14.15L8.225 11.8C8.09167 11.6667 7.925 11.6 7.725 11.6C7.525 11.6 7.35 11.675 7.2 11.825C7.05 11.975 6.975 12.15 6.975 12.35C6.975 12.55 7.05 12.725 7.2 12.875L9.95 15.625C10.1167 15.7917 10.325 15.875 10.575 15.875C10.825 15.875 11.0417 15.7917 11.225 15.625L16.8 10.025C16.9333 9.89167 17 9.725 17 9.525C17 9.325 16.925 9.15 16.775 9C16.625 8.85 16.45 8.775 16.25 8.775C16.05 8.775 15.875 8.85 15.725 9L10.575 14.15ZM12 21.5C10.6833 21.5 9.446 21.25 8.288 20.75C7.12933 20.25 6.125 19.575 5.275 18.725C4.425 17.875 3.75 16.8707 3.25 15.712C2.75 14.554 2.5 13.3167 2.5 12C2.5 10.6833 2.75 9.44567 3.25 8.287C3.75 7.129 4.425 6.125 5.275 5.275C6.125 4.425 7.12933 3.75 8.288 3.25C9.446 2.75 10.6833 2.5 12 2.5C13.3167 2.5 14.5543 2.75 15.713 3.25C16.871 3.75 17.875 4.425 18.725 5.275C19.575 6.125 20.25 7.129 20.75 8.287C21.25 9.44567 21.5 10.6833 21.5 12C21.5 13.3167 21.25 14.554 20.75 15.712C20.25 16.8707 19.575 17.875 18.725 18.725C17.875 19.575 16.871 20.25 15.713 20.75C14.5543 21.25 13.3167 21.5 12 21.5Z"
          fill="#00995C"
        />
      </g>
    </svg>
  )
}

export default CheckCircle
